<div class="error-message">
    <div class="error-message__container">
        <img alt="error" [src]="'images/error.svg' | assetUrl" class="black-icon cursor-pointer" draggable="false" />
        <div class="error-message__container-text">
            Oops! Something Went Wrong.
        </div>
    </div>
    <div class="error-message__subtext">
        No data available. Please verify the link or try again later. <br />
        If the issue persists, contact the EXP support team for assistance.
    </div>
</div>